import { render } from "./AllGalleriesShow.vue?vue&type=template&id=2734c77f"
import script from "./AllGalleriesShow.vue?vue&type=script&lang=js"
export * from "./AllGalleriesShow.vue?vue&type=script&lang=js"

import "./AllGalleriesShow.vue?vue&type=style&index=0&id=2734c77f&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__